import {Component, ViewChild} from '@angular/core';
import {
  AlertController, IonicApp,
  IonicPage, LoadingController, ModalController,
  NavController,
  NavParams,
} from 'ionic-angular';
import { UtilProvider } from '../../../providers/util/util';
import {HttpProvider} from "../../../providers/http/http";
import {CustomLoadingProvider} from "../../../providers/custom-loading/custom-loading";
import {ImageViewerController} from "ionic-img-viewer";
import {MyAlertProvider} from "../../../providers/my-alert/my-alert";
import {LargeImgPage} from "../../large-img/large-img";
import {global, Global} from "../../../environments/global";
import {PhotoclipPage} from "../../photoclip/photoclip";

/**
 * Generated class for the PullDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

/*IonicPage({
  segment:'detail/:chatroom/:scope',
  defaultHistory:['ChatroomPage']
})*/
@IonicPage({
  defaultHistory: ['PullHomePage', 'PullManageHomePage'],
  segment: 'pull-detail/:id'
})
@Component({
  selector: 'page-pull-detail',
  templateUrl: 'pull-detail.html',
})
export class PullDetailPage {

  global: Global = global;

  pages = ['拉群信息', '推送详情'];
  curPage = this.pages[0];

  //当前的活动 ID
  actEventId;

  //当前页面的 总数据源
  data;

  //活码二维码图片url
  qrCodeUrl: string;

  @ViewChild('qrWrapper') qrWrapper;

  //当前页面所属的进行状态
  status: string;

  //话术数据
  autoWords = {
    fission: {
      checked: true,
      word1:
        '嗨！恭喜您即将获取「3点钟无眠区块链」听课资格！\n' +
        '              1.转发以上图片+文字到朋友圈或者100以上群聊中\n' +
        '              2.不要屏蔽好友，转发后截图发至本群\n' +
        '              3.转发后在本群等待听课即可 分享图片及内容如下\n' +
        '              ↓↓↓↓↓',
      word2:
        '区块链行业大咖邀请您在4月28日收听课程【3点钟无眠区块链】\n' +
        '              名额有限 快扫码入群吧！',
    },
    condition: {
      checked: true,
      word:
        '3点种无眠区块链共同学习赚钱群，现在限时免费获取听课资格，满员开课哦！',
    },
    attract: {
      checked: true,
      word:
        '3点种无眠区块链共同学习赚钱群，现在限时免费获取听课资格，满员开课哦！',
    },
  };

  //控制是否显示保存按钮
  wordSettingDirty: boolean = false;

  //内含的所有群
  chatrooms = [];

  //删除活动回调
  deleteCallback;

  pc_host;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public http: HttpProvider,
    public csLoader: CustomLoadingProvider,
    public myAlert:MyAlertProvider,
    public loadingCtrl: LoadingController,
    public imageViewerCtrl: ImageViewerController,
    private modalCtrl: ModalController,
    public util: UtilProvider,
    public ionicApp: IonicApp
  ) {
    this.actEventId = navParams.get('act_id');
    this.pc_host = global.host_url.replace('https://wx.','');
    // this.status = navParams.get('status');
    // this.deleteCallback = navParams.get('deleteCallback');

  }

  ionViewWillLoad(){
    this.csLoader.showLoader();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PullDetailPage');

    this._getEventDetail(this.actEventId);
  }

  ionViewCanLeave(): boolean{
    return this.util.copeModal(this.ionicApp);
  }

  onPageChange(page) {
    this.curPage = page;
  }

  stopAct() {
    // let alert = this.alertCtrl.create({
    //   title: '停用提示',
    //   message: '关闭应用将不能再开启项目，是否确认 停用该活动',
    //   buttons: [
    //     {
    //       text: '取消',
    //       role: 'cancel',
    //       handler: () => {
    //         console.log('Cancel clicked');
    //       },
    //     },
    //     {
    //       text: '确认',
    //       handler: () => {
    //         console.log('Buy clicked');
    //         this.http.hPost('/events_delete', {event_id: this.actEventId}).subscribe(res => {
    //           this.deleteCallback(this.actEventId);
    //           this.navCtrl.pop();
    //         }, err=> {
    //           console.log('删除失败');
    //         });
    //       },
    //     },
    //   ],
    // });
    // alert.present();
  }

  private _getEventDetail(id){
    this.http.hPost('/acquisition/get_detail', {acquisition_id: id}).subscribe((res)=>{
      this.csLoader.dismissLoader();
      // if(res.err_code === 0){
      this.data = res.content;
      this.chatrooms = this.data.chatroom_info_list;

      //   this.autoWords.fission.word1 = res.content.fission_word_1;
      //   this.autoWords.fission.word2 = res.content.fission_word_2;
      //   this.autoWords.condition.word = res.content.condition_word;
      //   this.autoWords.attract.word = res.content.pull_people_word;
      //
      //   this.autoWords.fission.checked = res.content.need_fission;
      //   this.autoWords.condition.checked = res.content.need_condition_word;
      //   this.autoWords.attract.checked = res.content.need_pull_people;
      //
      //   this.data.start_time = new Date(this.data.start_time*1000);
      //   this.data.end_time = new Date(this.data.end_time*1000);
      //
      //   this.chatrooms = this.data.chatrooms;
      //   this.chatrooms.forEach(value => {
      //     switch (value.chatroom_status){
      //       case 0:{
      //         value.chatroom_status = '等待中';
      //         break;
      //       }
      //       case 1:{
      //         value.chatroom_status = '拉新中';
      //         break;
      //       }
      //       case 2:{
      //         value.chatroom_status = '满员';
      //         break;
      //       }
      //       default: {
      //         //outman temp
      //         alert('Wrong chatroom status: ' + value.chatroom_status);
      //       }
      //     }
      //   });
      //
      //   if(this.qrWrapper){
      //     // this.util.urlToQrcode(this.qrWrapper.nativeElement, this.data.alive_qrcode_url);
      //     //
      //     // //这一步是异步的
      //     // setTimeout(()=>{
      //     //   this.qrCodeUrl = this.qrWrapper.nativeElement.children[1].src;
      //     // }, 0);
      //     this.qrCodeUrl = this.data.alive_qrcode_url;
      //   }
      // } else {
      //
      // }
    });
  }

  saveWords(){
    let loading = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: '正在保存，请稍候'
    });

    loading.present();
    let params = {
      event_id:this.actEventId,
      need_fission:this.autoWords.fission.checked,
      need_condition_word : this.autoWords.condition.checked,
      need_pull_people : this.autoWords.attract.checked,
      fission_word_1:this.autoWords.fission.word1,
      fission_word_2:this.autoWords.fission.word2,
      condition_word :this.autoWords.condition.word,
      pull_people_word:this.autoWords.attract.word,
      // event_title :;
      // start_time:number;//秒
      // end_time:number;//秒
      // chatroom_name_protect:boolean;
      // poster_raw:string;
      // start_name:string;
    };
    this.http.hPost('/events_modify_v2',params).subscribe(res =>{
      loading.dismiss();
      this.wordSettingDirty = false;
    },err =>{
      loading.dismiss();
      this.wordSettingDirty = false;
      // let alertObj ={
      //   type:'error',
      //   title:'修改拉新任务失败',
      //   message: '修改拉新任务失败,请检查后重新提交',
      //   success: {
      //     text: '知道了',
      //   },
      // };
      // this.myAlert.showAlert(alertObj);
    });
    // setTimeout(()=>{
    //
    // }, 1000);
  }

  onDirty() {
    this.wordSettingDirty = true;
  }

  /**
   * 全屏显示二维码与海报图片*/
  fullscreen(index){
    let imgs = [{url:this.data.flexible_qrcode_url}];
    // if(!this.data.poster_raw){
    //   imgs = [{url:this.qrCodeUrl}];
    // }
    // else {
    //   imgs = [{url:this.qrCodeUrl}, {url:this.data.poster_raw}]
    // }
    /*this.navCtrl.push(LargeImgPage,{
      imgs:JSON.stringify(imgs),
      show_index:index
    })*/

    let modal = this.modalCtrl.create('LargeImgPage', {
      // imgs: imgs,
      imgs: JSON.stringify(imgs),
      show_index: index,
    });
    modal.present();
  }

  /**
   * 跳往截屏页面*/
  photoClip() {

    this.navCtrl.push(PhotoclipPage, {
      qrCode: this.qrCodeUrl,
      onClipFinished: postImgUrl => {
        console.log(postImgUrl);
        this.updatePoster(postImgUrl);
      },
    });
  }

  /**
   * 上传海报*/
  updatePoster(posterUrl){

    this.csLoader.showLoader();
    this.http.hPost('/events_modify_v2',{event_id: this.actEventId, poster_raw: posterUrl}).subscribe(res =>{
      this.csLoader.dismissLoader();
      this.data.poster_raw = posterUrl;
    },err =>{
      this.csLoader.dismissLoader();
      // let alertObj ={
      //   type:'error',
      //   title:'上传推广海报失败',
      //   message: global.bot_name + '遇到一些问题，请稍后再试',
      //   success: {
      //     text: '知道了',
      //   },
      // };
      // this.myAlert.showAlert(alertObj);
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/pull/pull-detail/pull-detail.ts